
import { defineComponent, ref, onMounted } from 'vue'
import {
    useRoute
} from 'vue-router';
import pservice from '@/core/services/PublicService';


export default defineComponent({
    name: "public-sport-cards",
    setup() {
        const route = useRoute();
        const { idevent, idsport } = route.params
        const link = ref<any>(null)

        const getMore = async () => {
            //loading.value = true
            await pservice.more({
                    evento: idevent,
                    sport: idsport
                })
                .then((res) => {
                    //loading.value = false
                    getLink(res.data.event.idevent)
                }).catch(({
                    response
                }) => {
                    //loading.value = false
                })
        }


        const getLink = (ideve) => {
            switch (idsport) {
            
              
                case 'futbol-masculino': //ok
                    link.value = `https://winscore.perufedup.com/publico/campeonatos/${ideve}/categorias/5/fechas/?informe=3`
                    break;
                case 'futsal-damas': //ok
                    link.value = `https://winscore.perufedup.com/publico/campeonatos/${ideve}/categorias/6/fechas/?informe=3`
                    break;
                case 'futsal-varones': //ok
                    link.value = `https://winscore.perufedup.com/publico/campeonatos/${ideve}/categorias/7/fechas/?informe=3`
                    break;
             
                case 'futbol-femenino':
                    link.value = `https://winscore.perufedup.com/publico/campeonatos/${ideve}/categorias/42/fechas/?informe=3`
                    break;
            }
        }

        onMounted(() => {
            getMore()
        })

        return {
            link,
            getMore

        }
    },
})
